<template>
    <ac-modal :title="'Payment Details'" ref="modal">
        <template v-if="widgetReady">
            <div class="row">
                <div v-for="fm in familyMembers" class="col-sm-12 col-md-6 col-lg-6">
                    <p><strong>{{ fm.relationshipToConsumer }}:</strong> {{ fm.patient }}</p>
                    <p><strong>Primary:</strong> {{ fm.mainConsumer }}</p>
                    <p><strong>Individual Cost:</strong> {{ fm.individualCost |currency }}</p>
                    <p><strong>Provider Selection:</strong> {{ fm.planEffectiveDate | shortDate }}</p>
                    <p><strong>DiscountId: </strong> {{ fm.discountSettingsId }}</p>
                    <div>
                        <strong>Fees: </strong>
                        <p v-for="f in fm.feeDetails">
                            {{ f }}<br>
                        </p>
                    </div>
                    <p><strong>Notes: </strong>{{ fm.notes }}</p>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import AcModal from "../../../../../global/customHtmlElements/AcModal.vue";
    import {api} from "../../../../../global/framework/api.js";

    export default {
        name: "PaymentDetailsModal",
        components: {AcModal},
        data() {
            return {
                widgetReady: false,
                familyMembers: []
            };
        },
        methods: {
            async showModal({companyPaymentId, consumerId}) {
                this.widgetReady = false;
                this.familyMembers = await api.get('PaymentReport', companyPaymentId, 'GetCompanyPaymentDetails');
                this.familyMembers = this.familyMembers.filter((el) => el.consumerId == consumerId);
                this.widgetReady = true;
                this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>
    strong {
        font-weight: bold !important;
    }
</style>